var render = function render(){var _vm=this,_c=_vm._self._c;return _c('node-view-wrapper',{class:{ 'it-component__wrapper': _vm.isEditable },attrs:{"origin":_vm.node.attrs.origin}},[_c(_vm.component,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }